import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import { adjustPartnerDetails, getPartnerDetailsByPartnerOrgId } from 'redux/modules/teamManagement';
import { addContract, editContract } from 'redux/modules/newContract';
import { GrayButton, ModalTopBar, SecondaryButton, PageHeader, Spinner } from 'components';
import { LeftNavLayout } from 'containers';
import PartnerAdjustmentFields from './PartnerAdjustmentFields';
import * as styles from './PartnerAdjustmentForm.scss';

var moment = require('moment');

var PartnerAdjustmentForm = (_dec = connect(function (state) {
  return {
    contract: state.contract,
    organization: state.organization.current,
    allContracts: state.contract.allContracts,
    isLoadingContracts: state.contract.isLoadingContracts,
    partnerDetails: state.teamManagement.partnerDetails,
    adjustingPartnerDetails: state.teamManagement.adjustingPartnerDetails,
    theme: state.theme
  };
}, {
  addContract: addContract,
  editContract: editContract,
  adjustPartnerDetails: adjustPartnerDetails,
  getPartnerDetailsByPartnerOrgId: getPartnerDetailsByPartnerOrgId
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PartnerAdjustmentForm, _Component);

  var _super = _createSuper(PartnerAdjustmentForm);

  function PartnerAdjustmentForm(props) {
    var _this;

    _classCallCheck(this, PartnerAdjustmentForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatDollars", function (num) {
      return parseInt(num).toLocaleString();
    });

    _defineProperty(_assertThisInitialized(_this), "handleFormFieldChange", function (field, val) {
      _this.setState({
        formValues: _objectSpread(_objectSpread({}, _this.state.formValues), {}, _defineProperty({}, field, val))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      _this.setState({
        disableSubmit: true
      });

      _this.props.adjustPartnerDetails(_this.props.theme.org, _this.state.formValues).then(function (newContract) {
        _this.setState({
          disableSubmit: false
        });

        _this.props.handleCloseAfterSubmit();
      });
    });

    _this.state = {
      disableSubmit: false,
      formValues: {
        additionalClients: '0',
        additionalTeamMembers: '0'
      }
    };
    return _this;
  }

  _createClass(PartnerAdjustmentForm, [{
    key: "render",
    value: function render() {
      var contractInfo = this.props.partnerDetails;
      var additionalClientCost = contractInfo ? this.state.formValues.additionalClients * contractInfo.terms.additionalClientsMonthlyPrice : 0;
      var additionalTeamMembersCost = contractInfo ? this.state.formValues.additionalTeamMembers * contractInfo.terms.additionalTeamMembersMonthlyPrice : 0;
      var newMonthlyTotal = contractInfo ? contractInfo.totals.totalBillCalculated + additionalClientCost + additionalTeamMembersCost : 0;
      var addClientActions = [/*#__PURE__*/React.createElement(GrayButton, {
        label: "Cancel",
        onClick: this.props.handleClose,
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Submit",
        onClick: this.handleSubmit,
        disabled: this.state.disableSubmit
      })];
      return /*#__PURE__*/React.createElement(Dialog, {
        title: this.props.title,
        titleStyle: {
          color: this.props.theme.colors.primaryColor
        },
        actions: addClientActions,
        autoScrollBodyContent: true,
        open: this.props.show,
        onRequestClose: this.props.handleClose
      }, contractInfo && this.props.showClientField && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          lineHeight: '20px'
        }
      }, "Your current plan only allows ", contractInfo.totals.clientsPermitted, " clients - and you've already used them."), /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          lineHeight: '20px'
        }
      }, "You need to adjust your plan before you can add more clients.", /*#__PURE__*/React.createElement("br", null), "Each new client will add $", contractInfo.terms.additionalClientsMonthlyPrice, "/mo to your bill.")), contractInfo && this.props.showTeamMemberField && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          lineHeight: '20px'
        }
      }, "Your current plan only allows ", contractInfo.totals.teamMembersPermitted, " team members - and you've already used them."), /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          lineHeight: '20px'
        }
      }, "You need to adjust your plan before you can add more team members.", /*#__PURE__*/React.createElement("br", null), "Each new team member will add $", contractInfo.terms.additionalTeamMembersMonthlyPrice, "/mo to your bill.")), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.props.adjustingContract ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-6 ".concat(styles.scrollSection)
      }, /*#__PURE__*/React.createElement(PartnerAdjustmentFields, {
        showTeamMemberField: this.props.showTeamMemberField,
        showClientField: this.props.showClientField,
        handleFormFieldChange: this.handleFormFieldChange,
        formValues: this.state.formValues,
        style: {
          paddingRight: 36
        },
        handleLeave: this.handleLeave,
        handleSubmit: this.handleSubmit,
        sendingContract: this.state.sendingContract
      })), /*#__PURE__*/React.createElement("div", {
        className: 'col-xs-12 col-sm-6'
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.preview
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Current Bill Amount"), /*#__PURE__*/React.createElement("span", {
        className: styles.value
      }, "$", this.formatDollars(contractInfo.totals.totalBillCalculated))), contractInfo && this.props.showClientField && /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, this.state.formValues.additionalClients, " Additional Clients"), /*#__PURE__*/React.createElement("span", {
        className: styles.value
      }, "$", this.formatDollars(additionalClientCost))), contractInfo && this.props.showTeamMemberField && /*#__PURE__*/React.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, this.state.formValues.additionalTeamMembers, " Additional Team Members"), /*#__PURE__*/React.createElement("span", {
        className: styles.value
      }, "$", this.formatDollars(additionalTeamMembersCost))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.item, " ").concat(styles.totalItem)
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "New Monthly Total"), /*#__PURE__*/React.createElement("span", {
        className: styles.value
      }, "$", this.formatDollars(newMonthlyTotal)))), /*#__PURE__*/React.createElement("span", {
        className: styles.finePrint
      }, "Your next bill will also include a pro-rated charge for your additional clients for the remainder of the current billing cycle."))))))));
    }
  }]);

  return PartnerAdjustmentForm;
}(Component), _defineProperty(_class2, "defaultProps", {
  showClientField: true,
  showTeamMemberField: false
}), _temp)) || _class);
export default PartnerAdjustmentForm;